import Vue from 'vue'

//** Date picker */

import Datepicker from 'vuejs-datepicker'
Vue.component('Datepicker', Datepicker)

//** Moment */
Vue.use(require('vue-moment'))

//** Vue-autosuggest */
import VueAutosuggest from "vue-autosuggest"
Vue.use(VueAutosuggest)

//** Masked input */
import MaskedInput from 'vue-masked-input'
Vue.component('MaskedInput', MaskedInput)

//** Infinite scroll */
import InfiniteLoading from 'vue-infinite-loading'
Vue.use(InfiniteLoading, {
    props: {
        spinner: 'spiral'
    },
    slots: {
        noMore: 'Отображены все доступные данные',
        noResults: 'Данных нет'
    }
})

//** Tooltip */
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

//** v-mask */
import VueMask from 'v-mask'
Vue.use(VueMask);

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper);
import Swiper, { Navigation, Pagination } from 'swiper'
Swiper.use([Navigation, Pagination])
 
// import style
import 'swiper/swiper-bundle.css'